import React from 'react'
import { Fragment } from 'react'
import { Col, Container, Row } from 'react-bootstrap'

const Terms = () => {
    return (
        <Fragment>
            <section className='pb-0'>
                <Container>
                    <div className="text-center">
                        <h2 className='font-medium text__48 mb-2'>Terms & Conditions</h2>
                        <p className='text__16 text-[#525252]'>Effective Date: August 18, 2025</p>
                    </div>
                </Container>
            </section>

            <section>
                <Container>
                    <Row className='justify-center'>
                        <Col md={10}>

                            <div className="mb-4">
                                <h5 className='font-medium text__18 mb-2'>1. About Pantria</h5>
                                <p className='text__16'>Pantria, operated by  Ltd (Company Registration Number: ), is a UK-based food marketplace platform connecting home cooks with local food lovers. These Terms & Conditions govern your use of our platform and services.</p>
                            </div>

                            <div className="mb-4">
                                <h5 className='font-medium text__18 mb-2'>2. Acceptance of Terms</h5>
                                <p className='text__16'>By accessing or using Pantria, you agree to be bound by these Terms & Conditions and our Privacy Policy. If you disagree with any part of these terms, you may not use our service. These terms are governed by English law and are subject to UK jurisdiction.</p>
                            </div>

                            <div className="mb-4">
                                <h5 className='font-medium text__18 mb-2'>3. User Accounts</h5>
                                <p className='text__16 mb-2'>You must provide accurate, complete, and current information when creating an account. You are responsible for maintaining account security and all activities under your account.</p>
                                <p className='text__16'><strong>For Sellers:</strong> Additional verification may be required including food hygiene certificates, kitchen registration, and identity verification.</p>
                            </div>

                            <div className="mb-4">
                                <h5 className='font-medium text__18 mb-2'>4. Food Safety & Seller Responsibilities</h5>
                                <p className='text__16 mb-2'>Sellers must:</p>
                                <ul className='text__16 ml-4 mb-2'>
                                    <li>Comply with UK food safety regulations and Food Standards Agency guidelines</li>
                                    <li>Maintain valid food hygiene certificates (Level 2 minimum recommended)</li>
                                    <li>Register their food business with local authorities where required</li>
                                    <li>Provide accurate allergen information for all products</li>
                                    <li>Maintain proper food storage, preparation, and hygiene standards</li>
                                    <li>Ensure food is prepared in suitable kitchen facilities</li>
                                    <li>Label food with preparation and use-by dates</li>
                                </ul>
                                <p className='text__16'>Failure to comply may result in account suspension or termination.</p>
                            </div>

                            <div className="mb-4">
                                <h5 className='font-medium text__18 mb-2'>5. Prohibited Activities</h5>
                                <p className='text__16 mb-2'>You may not:</p>
                                <ul className='text__16 ml-4 mb-2'>
                                    <li>Sell food that is unsafe, expired, or improperly stored</li>
                                    <li>Misrepresent ingredients, allergens, or preparation methods</li>
                                    <li>Operate without required licenses or certifications</li>
                                    <li>Engage in fraudulent activities or spam</li>
                                    <li>Violate any applicable laws or regulations</li>
                                    <li>Interfere with other users' use of the platform</li>
                                </ul>
                            </div>

                            <div className="mb-4">
                                <h5 className='font-medium text__18 mb-2'>6. Orders & Payments</h5>
                                <p className='text__16 mb-2'>Orders are contracts between buyers and sellers. Pantria facilitates the transaction but is not a party to the sale. Payment processing is handled by third-party providers (Stripe, PayPal).</p>
                                <p className='text__16'>Sellers are responsible for order fulfillment, quality, and food safety. Buyers have rights under UK consumer protection laws.</p>
                            </div>

                            <div className="mb-4">
                                <h5 className='font-medium text__18 mb-2'>7. Consumer Rights (UK)</h5>
                                <p className='text__16 mb-2'>Under UK consumer law, you have the right to:</p>
                                <ul className='text__16 ml-4 mb-2'>
                                    <li>Receive food that matches its description</li>
                                    <li>Receive food of satisfactory quality and fit for purpose</li>
                                    <li>Refunds for unsatisfactory purchases (subject to food safety considerations)</li>
                                    <li>Protection against unfair contract terms</li>
                                </ul>
                                <p className='text__16'>These rights are not affected by these Terms & Conditions.</p>
                            </div>

                            <div className="mb-4">
                                <h5 className='font-medium text__18 mb-2'>8. Liability & Disclaimers</h5>
                                <p className='text__16 mb-2'>Pantria acts as an intermediary platform. We do not prepare, store, or handle food products. Sellers are responsible for food safety, quality, and compliance with regulations.</p>
                                <p className='text__16'>We exclude liability for food-related illness or injury except where prohibited by law. Our maximum liability is limited to the transaction value or £100, whichever is lower.</p>
                            </div>

                            <div className="mb-4">
                                <h5 className='font-medium text__18 mb-2'>9. Intellectual Property</h5>
                                <p className='text__16'>The Pantria platform, logo, and original content are owned by Quenra Ltd. Users retain rights to their own content but grant us license to use it on the platform.</p>
                            </div>

                            <div className="mb-4">
                                <h5 className='font-medium text__18 mb-2'>10. Termination</h5>
                                <p className='text__16'>We may suspend or terminate accounts for breach of these terms, food safety violations, or illegal activities. Users may close their accounts at any time.</p>
                            </div>

                            <div className="mb-4">
                                <h5 className='font-medium text__18 mb-2'>11. Dispute Resolution</h5>
                                <p className='text__16 mb-2'>We encourage users to resolve disputes directly. For unresolved issues, UK consumers may use Alternative Dispute Resolution services or small claims court.</p>
                                <p className='text__16'>These terms are governed by English law, with English courts having jurisdiction.</p>
                            </div>

                            <div className="mb-4">
                                <h5 className='font-medium text__18 mb-2'>12. Changes to Terms</h5>
                                <p className='text__16'>We may update these terms with 30 days' notice for material changes. Continued use constitutes acceptance of new terms.</p>
                            </div>

                            <div className="mb-4">
                                <h5 className='font-medium text__18 mb-2'>13. Contact Information</h5>
                                <p className='text__16 mb-2'><strong>Company:</strong> Quenra Ltd</p>
                                <p className='text__16 mb-2'><strong>Email:</strong> hello@pantria.co</p>
                                <p className='text__16'>For complaints or legal matters, please use the contact information above. UK consumers may also contact Citizens Advice or Trading Standards for additional support.</p>
                            </div>

                        </Col>
                    </Row>
                </Container>
            </section>
        </Fragment>
    )
}

export default Terms